import { memo } from 'react';
import styles from './Message.module.css';
import cn from 'classnames';
import { TextWithStyledDigits } from '../TextWithStyledDigits/TextWithStyledDigits';

const Message = ({
  className,
  message,
  isCurrent,
  currentState,
  msgFontSize,
  clicker,
}) => {
  return (
    <div className={cn(styles['wrapper'], className)}>
      {message?.content && (
        <div
          style={{
            fontSize: `${msgFontSize}rem`,
          }}
          className={cn(
            styles['text'],
            isCurrent && styles['isCurrent'],
            (['S4', 'S8'].includes(currentState) || clicker === 'PageUp') &&
              isCurrent &&
              styles['isWinner']
          )}>
          <TextWithStyledDigits
            text={message?.content}
            fontSize={`${msgFontSize * 1.2}rem`}
          />
        </div>
      )}
    </div>
  );
};

export default memo(Message);
